// extracted by mini-css-extract-plugin
module.exports = {"text":"_4e5f713ae4--text--rbvzp"};